import { RecommenderPopup } from '@jo-v1/components';
import JoEmbeddedRecommender from '@jo-v1/features/JoEmbeddedRecommender';
import { type FC } from 'react';

import { ALGOLIA_BASE_INDEX_NAME } from '@core/services/AlgoliaService/v2';
import { AddActiveProspectScript } from '@core/utils/scripts/AddActiveProspectScript';

import type { EduResultsProps } from '../eduResults/types';
import DuplicatePopup from './components/DuplicatePopup';
import JoComparisonBanner from './components/JoComparisonBanner';
import JoComparisonModal from './components/JoComparisonModal';
import { NoResults } from './components/NoResults';
import ResultsList from './components/ResultsList';
import SubmissionSlideOut from './components/SubmissionSlideOut';

const JoV1EduResultsUI: FC<EduResultsProps> = ({
  showEmbeddedRecommender,
  recommenderData,
  isActiveProspectScriptRequired,
  showDuplicatePopup,
  dcsConsolidationResults,
  searchClient,
  popupData,
  popupEventing,
  exactResults,
  consolidatedResults,
  showUgToGradResultsPageABTest,
  unborrowedMatches,
  isComparisonTest,
  subject,
}) => (
  <>
    {/* Handle Trusted Certificate */}
    {isActiveProspectScriptRequired && <AddActiveProspectScript />}
    {showDuplicatePopup && <DuplicatePopup searchClient={searchClient} indexName={ALGOLIA_BASE_INDEX_NAME} />}
    <RecommenderPopup results={popupData ?? []} eventingOverrides={popupEventing} />
    <SubmissionSlideOut />
    <JoEmbeddedRecommender results={recommenderData ?? []} eventingOverrides={popupEventing ?? {}} />
    {dcsConsolidationResults?.length > 0 ? (
      <ResultsList
        header="More Matches For You"
        subheader={`These schools offer programs in ${subject} or areas closely related to this subject.`}
        results={exactResults}
        borrowedResults={consolidatedResults}
        showUgToGradResultsPageABTest={showUgToGradResultsPageABTest}
      />
    ) : (
      ((showEmbeddedRecommender && recommenderData?.length && recommenderData?.length < 1) ||
        !showEmbeddedRecommender) &&
      unborrowedMatches?.length < 1 && <NoResults />
    )}
    {unborrowedMatches?.length > 0 && (
      <ResultsList
        isRelatedResults
        header="Related Results"
        subheader={`These schools offer similar programs to ${subject}.`}
        results={unborrowedMatches}
      />
    )}
    {isComparisonTest && (
      <>
        <JoComparisonBanner />
        <JoComparisonModal />
      </>
    )}
  </>
);

export default JoV1EduResultsUI;
